"use strict";
var provider_1 = require('./provider');
function isProviderLiteral(obj) {
    return obj && typeof obj == 'object' && obj.provide;
}
exports.isProviderLiteral = isProviderLiteral;
function createProvider(obj) {
    return new provider_1.Provider(obj.provide, obj);
}
exports.createProvider = createProvider;
//# sourceMappingURL=provider_util.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular/core/src/di/provider_util.js
 ** module id = 196
 ** module chunks = 0
 **/